export default __webpack_public_path__ + "static/media/hp.5c2b1d2b.svg";